import { request } from '../request';

/**
 * 获取已启用业务类目
 * GET /business-categories
 *
 * @returns 已启用的业务类目列表
 */
export function fetchBusinessCategories() {
  return request<Api.BusinessCategory.BusinessCategoryResponse[]>({
    url: '/business-categories',
    method: 'get'
  });
}
